(function (cny, $) {
	cny.functionName = function () {
		var $container = $('');
		if (!$container.length) {
			return;
		}
	};
}(window.cny = window.cny || {}, jQuery));
